import PropTypes from 'prop-types';
import ActiveUserFlagStore from 'contest/stores/active-user-flag-store';
import OnboardingPromptStore from 'contest/stores/onboarding-prompt-store';
import ContestsActiveUserStore from 'contest/stores/ContestsActiveUserStore';
import { dismissOnboardingPrompt } from 'contest/actions/dismiss-onboarding-prompt';
import { connectToStores } from 'fluxible-addons-react';
import registeredComponentOrChildren from 'contest/components/onboarding-prompts/registeredComponentOrChildren';

/**
 * For displaying an onboarding prompt that can be dismissed and is mutually exclusive to others
 * Tip: you can set a priority to control the order, a higher number means higher priority
 * e.g. let MyPrompt = onboardingPrompt('my-prompt', 500, MyPrompt);
 */
export default function onboardingPrompt(promptKey, priority, OnboardingComponent) {
    const ConnectedExclusiveOnboardingPrompt = connectToStores(
        registeredComponentOrChildren(OnboardingComponent),
        [ActiveUserFlagStore, OnboardingPromptStore, ContestsActiveUserStore],
        (context, { promptKeySuffix }) => {
            const fullPromptKey = promptKey + (promptKeySuffix ? `_${promptKeySuffix}` : '');
            return {
                isActive: () => {
                    const user = context.getStore(ContestsActiveUserStore).activeUser;
                    if (user.role !== 'owner' && user.role !== 'designer') return;
                    const prompts = context.getStore(OnboardingPromptStore).getPrompts();
                    const rankedPrompts = Object.keys(prompts)
                        .filter(key => {
                            return !context
                                .getStore(ActiveUserFlagStore)
                                .has(`onboarding-dismiss_${key}`);
                        })
                        .sort((k1, k2) => prompts[k2] - prompts[k1]);

                    return rankedPrompts.length > 0 && rankedPrompts[0] === fullPromptKey;
                },
                dismiss: () => {
                    context.executeAction(dismissOnboardingPrompt, { key: fullPromptKey });
                },
                register: () => {
                    context.getStore(OnboardingPromptStore).register(fullPromptKey, priority);
                },
                unregister: () => {
                    context.getStore(OnboardingPromptStore).register(fullPromptKey, priority);
                },
            };
        }
    );

    ConnectedExclusiveOnboardingPrompt.contextTypes = {
        getStore: PropTypes.func,
        executeAction: PropTypes.func,
    };

    return ConnectedExclusiveOnboardingPrompt;
}



// WEBPACK FOOTER //
// ./src/web/js/contest/components/onboarding-prompts/onboardingPrompt.js